














import { Vue, Component, Prop } from 'vue-property-decorator'
import DoalogSlot from '@/components/dialog/doalogSlot.vue'
@Component({
  components: {
    DoalogSlot,
  },
})
export default class ProductInfoAnalysis extends Vue {
    @Prop()settingProductAnalysisShow!: boolean
}
